export default "__VITE_ASSET__C5DKk_wc__"